"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyCustomStyle = exports.sanitizeCustomStyle = void 0;
/**
 * Filters a stored value into a CustomStyle. Drops keys with the wrong
 * primitive type and keeps the rest as-is (the CSS emitter is forgiving).
 */
const sanitizeCustomStyle = (v) => {
    if (!v || typeof v !== 'object' || Array.isArray(v))
        return undefined;
    const src = v;
    const out = {};
    const num = (k) => {
        const x = src[k];
        if (typeof x === 'number' && Number.isFinite(x))
            out[k] = x;
    };
    const str = (k) => {
        const x = src[k];
        if (typeof x === 'string' && x.length)
            out[k] = x;
    };
    const bool = (k) => {
        const x = src[k];
        if (typeof x === 'boolean')
            out[k] = x;
    };
    str('ff');
    num('fz');
    num('fw');
    num('fs');
    bool('os');
    str('lig');
    str('nv');
    num('lh');
    num('ls');
    num('ws');
    str('krn');
    bool('it');
    bool('caps');
    bool('smcp');
    num('uo');
    num('dt');
    str('fg');
    str('bg');
    return Object.keys(out).length ? out : undefined;
};
exports.sanitizeCustomStyle = sanitizeCustomStyle;
const isEmptyCustomStyle = (cs) => !cs || Object.keys(cs).length === 0;
exports.isEmptyCustomStyle = isEmptyCustomStyle;
